import * as classnames from 'classnames';
import * as React from 'react';

import { History } from 'history';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';

import * as AppConstant from 'constants/app';

import { Accordion } from 'components/Accordion';
import { LinkWithAnalytics } from 'components/LinkWithAnalytics';
import { Sidemenu } from 'components/Sidemenu';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'constants/analytics';
import { sendEvent } from 'helper/analytics';

import './LayoutSidemenu.scss';

interface LayoutSidemenuProps {
  history: History;
  isOpen: boolean;
  onLogout: MSExecAtPriorityFunctionCallback;
  toggleMenu: MSExecAtPriorityFunctionCallback;
}

interface LayoutSidemenuState {
  currentPathname: string;
}

export class LayoutSidemenu extends React.Component<LayoutSidemenuProps, LayoutSidemenuState> {
  constructor(props: LayoutSidemenuProps) {
    super(props);

    this.state = {
      currentPathname: ''
    };
  }

  componentDidUpdate() {
    this.updateCurrentPathname();
  }

  render() {
    const { isOpen, toggleMenu } = this.props;
    const classNameHomeActive = this.isCurrentPathnameEqual(AppConstant.ROUTE_WALLET_DASHBOARD) && 'layout-sidemenu__navigation-li--is-active';
    return (
      <Sidemenu
        className="layout-sidemenu"
        isOpen={isOpen}
        onOverlayClick={toggleMenu}
      >
        <div className="layout-sidemenu__header">
          <a className="layout-sidemenu__close">
            <i onClick={toggleMenu} className="o-icon-action ic-close"/>
          </a>
        </div>

        <div className="layout-sidemenu__container">
          <ul className="layout-sidemenu__navigation-ul">
            <li className={classnames('layout-sidemenu__navigation-li', classNameHomeActive)}>
              <LinkWithAnalytics
                className="layout-sidemenu__navigation-link"
                onClick={toggleMenu}
                to={AppConstant.ROUTE_WALLET_DASHBOARD}
                category={AnalyticsEventCategory.MENU_BUTTON}
                action={AnalyticsEventAction.OPEN_WALLET_DASHBOARD_PAGE}
              >
                <i className="layout-sidemenu__navigation-icon o-icon-action ic-home"/>
                <FormattedMessage id="menu.home"/>
              </LinkWithAnalytics>
            </li>
            <li className="layout-sidemenu__navigation-accordion-container">
              <Accordion title={this.accountTitle}>
                <ul className="layout-sidemenu__navigation-accordion-ul">
                  <li className="layout-sidemenu__navigation-accordion-li">
                    <LinkWithAnalytics
                      className="layout-sidemenu__navigation-accordion-link"
                      onClick={toggleMenu}
                      to={AppConstant.ROUTE_ACCOUNT_EMAIL_UPDATE}
                      category={AnalyticsEventCategory.MENU_BUTTON}
                      action={AnalyticsEventAction.OPEN_ACCOUNT_CHANGE_EMAIL_PAGE}
                    >
                      <FormattedMessage id="menu.email.update"/>
                    </LinkWithAnalytics>
                  </li>
                  <li className="layout-sidemenu__navigation-accordion-li">
                    <LinkWithAnalytics
                      className="layout-sidemenu__navigation-accordion-link"
                      onClick={toggleMenu}
                      to={AppConstant.ROUTE_ACCOUNT_PASSWORD_UPDATE}
                      category={AnalyticsEventCategory.MENU_BUTTON}
                      action={AnalyticsEventAction.OPEN_ACCOUNT_CHANGE_PASSWORD_PAGE}
                    >
                      <FormattedMessage id="menu.password.update"/>
                    </LinkWithAnalytics>
                  </li>
                </ul>
              </Accordion>
            </li>
          </ul>

          <footer className="layout-sidemenu__footer">
            <p className="layout-sidemenu__footer-paragraph">
              <LinkWithAnalytics
                className="layout-sidemenu__footer-link"
                onClick={toggleMenu}
                to={AppConstant.ROUTE_STATIC_CONTACT_US}
                category={AnalyticsEventCategory.MENU_BUTTON}
                action={AnalyticsEventAction.OPEN_CONTACT_US_PAGE}
              >
                <FormattedMessage id="menu.contactUs"/>
              </LinkWithAnalytics>
            </p>
            <p className="layout-sidemenu__footer-paragraph">
              <LinkWithAnalytics
                className="layout-sidemenu__footer-link"
                onClick={toggleMenu}
                to={AppConstant.ROUTE_STATIC_TERM}
                category={AnalyticsEventCategory.MENU_BUTTON}
                action={AnalyticsEventAction.OPEN_TERMS_AND_CONDITION_PAGE}
              >
                <FormattedMessage id="menu.term"/>
              </LinkWithAnalytics>
            </p>
            <p className="layout-sidemenu__footer-paragraph">
              <LinkWithAnalytics
                className="layout-sidemenu__footer-link"
                onClick={toggleMenu}
                to={AppConstant.ROUTE_STATIC_FAQ}
                category={AnalyticsEventCategory.MENU_BUTTON}
                action={AnalyticsEventAction.OPEN_FAQ_PAGE}
              >
                <FormattedMessage id="menu.faq"/>
              </LinkWithAnalytics>
            </p>
            <p className="layout-sidemenu__footer-paragraph">
              <a className="layout-sidemenu__logout" onClick={this.onLogoutClick()}>
                <FormattedMessage id="menu.logout"/>
              </a>
            </p>
            <p className="layout-sidemenu__footer-paragraph layout-sidemenu__copyright">
              <FormattedHTMLMessage id="footer.copyright"/>
            </p>
          </footer>
        </div>
      </Sidemenu>
    );
  }

  get accountTitle() {
    return (
      <div className="layout-sidemenu__navigation-accordion-title">
        <i className="layout-sidemenu__navigation-icon o-icon-action ic-user"/> <FormattedMessage id="menu.account"/>
      </div>
    );
  }

  private onLogoutClick() {
    return () => {
      sendEvent({
        action: AnalyticsEventAction.ACCOUNT_LOG_OUT,
        category: AnalyticsEventCategory.MENU_BUTTON
      });
      this.props.onLogout();
    };
  }

  private isCurrentPathnameEqual(pathname: string) {
    const { currentPathname } = this.state;
    return currentPathname.indexOf(pathname) >= 0;
  }

  private updateCurrentPathname() {
    const { history } = this.props;
    const { currentPathname } = this.state;
    if (history.location.pathname !== currentPathname) {
      this.setState({ currentPathname: history.location.pathname });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Layout/LayoutSidemenu/LayoutSidemenu.tsx